module.exports = __webpack_public_path__ + "img/pr-1.bc3e7102.png";